
const detail = {
  path: 'detail',
  component: resolve => require(['../../../../../pages/modules/knowledge/detail'], resolve),
}

export default detail
